export default __webpack_public_path__ + "static/The-Race-f0f4f5bdc8fd53fcbc0a34d34ee74c8e.mp3";